<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <!-- Header Wave -->
  <div class="dialog-wave-header dialog-wave-header--success">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ tituloDialog }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Body -->
  <div class="dialog-wave-body" *ngIf="titulo">
    <div class="recebimento-info">
      <div class="info-row">
        <span class="info-label">{{ labels.titulo_numero }}:</span>
        <span class="info-value">#{{ titulo.numero }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">{{ labels.saldo_titulo }}:</span>
        <span class="info-value saldo-value">{{ titulo.saldo | number:'1.0-0' }}</span>
      </div>
    </div>

    <div class="recebimento-input">
      <label for="valorRecebimento">{{ labelValor }}</label>
      <p-inputNumber
        id="valorRecebimento"
        [(ngModel)]="valorRecebimento"
        [monetaryMask]="0"
        [min]="1"
        [max]="titulo.saldo"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="0"
        [useGrouping]="true"
        [disabled]="processando"
        [style]="{ width: '100%' }"
        [inputStyle]="{ width: '100%' }">
      </p-inputNumber>
      <small class="erro-validacao" *ngIf="erroValidacao">{{ erroValidacao }}</small>
    </div>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <button pButton
      [label]="botoes.cancelar"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fechar()">
    </button>
    <button pButton
      [label]="botoes.confirmar"
      severity="success"
      icon="pi pi-check-circle"
      [loading]="processando"
      (click)="onConfirmar()">
    </button>
  </ng-template>
</p-dialog>
